"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_LOCALE = exports.LOCALES = void 0;
exports.resolveLocale = resolveLocale;
exports.isLocale = isLocale;
exports.LOCALES = ['uk', 'en'];
exports.DEFAULT_LOCALE = 'en';
const UK_LANGUAGE_CODES = new Set(['uk', 'ru']);
/** Maps a Telegram language_code (for example "uk", "ru", "en-US") to a supported locale. */
function resolveLocale(languageCode) {
    if (!languageCode)
        return exports.DEFAULT_LOCALE;
    const primary = languageCode.toLowerCase().split('-')[0] ?? '';
    return UK_LANGUAGE_CODES.has(primary) ? 'uk' : 'en';
}
function isLocale(value) {
    return typeof value === 'string' && exports.LOCALES.includes(value);
}
//# sourceMappingURL=locale.js.map